import React, { useEffect, useContext, useState, useCallback } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { PullToRefresh } from '../../commons/PullToRefresh'
import { InfiniteScroll } from '../../commons/InfiniteScroll'
import { useRouter } from 'next/router'
import { NewBuzz } from '../../home/buzz/NewBuzz'
import { downloadMyBuzz, removeLikeAction, uploadAction } from '../../../api/post/buzz-api'
import { UserContext } from '../../../context/UserContext'
import globalStore from '../../../service/global-store'
import { ImageModal } from '../../commons/ImageModal'
import { LoadingCover } from '../../commons/LoadingCover'
import { SystemError } from '../../error/SystemError'
import { openModal } from '../../../service/modal-service'
import { BuzzDelete } from './BuzzDelete'
import { BuzzPrivacy } from './BuzzPrivacy'
import { openImageHandler } from '../../../js/open-image'
import { shareContent } from '../../../service/share-content'
import { ShareFallbackModal } from '../../commons/ShareFallbackModal'
import { ChevronLeft, MessageCircle, Plus } from 'lucide-react'
import DotLoader from 'react-spinners/DotLoader'
import { SkeletonCard } from '../../home/buzz/SkeletonLoader'
import { BuzzCard } from '../../home/buzz/BuzzCard'

export const MyBuzz = (props) => {
    const router = useRouter()
    const myPosts = props.myPosts
    
    const stringHandleName = props.stringHandleName
    const stringsUserId = props.stringsUserId

    const storeKey = "my-buzz"

    const [ buzzLowerLimit , setBuzzLowerLimit ] = useState(0)
    const [ buzzIncrementSize ] = useState(6)
    const [ buzzArray, setBuzzArray ] = useState([])
    const [ isShowMoreBuzz, setIsShowMoreBuzz ] = useState(true)
    const [ isLoadingBuzz, setIsLoadingBuzz ] = useState(false)

    const [ isShowPostPrivacy, setIsShowPostPrivacy ] = useState(false)
    const [ isShowPostDelete, setIsShowPostDelete ] = useState(false)
    const [ isOpenMedia, setIsOpenMedia] = useState(false)
    const [ buzzMedia, setBuzzMedia ] = useState(undefined)
    const [ buzzMediaType, setBuzzMediaType ] = useState("")
    const [ imageX, setImageX ] = useState(0)
    const [ imageY, setImageY ] = useState(0)
    const [ viewEntityId, setViewEntityId ] = useState("")
    const [ isMuteVideo, setIsMuteVideo ] = useState(true)
    const [ isPauseVideo, setIsPauseVideo ] = useState(false)

    const [ editEntityId, setEditEntityId ] = useState("")
    const [ postSecurity, setPostSecurity ] = useState("")
    const [ isShowNewBuzzmodal, setIsShowNewBuzzModal ] = useState(false)
    const [ showShareModal, setShowShareModal ] = useState(false)
    const [ shareData, setShareData ] = useState(null)

    const [ isLoading, setIsLoading ] = useState(false)
    const [ isSystemError, setIsSystemError ] = useState(false)
    const [ errorContent, setErrorContent ]  = useState({'header': "", 'body': ""})

    const { userId, userFullName } = useContext(UserContext)

    useEffect(() => {
        if(!stringsUserId) return
        setBuzzArray(myPosts)
        setBuzzLowerLimit(myPosts.length)
    }, [stringsUserId, myPosts])

    const openImage = (event, media, mediaType) => {
        openImageHandler(event, setImageX, setImageY)
        setBuzzMedia(media);
        setBuzzMediaType(mediaType)
        openModal(setIsOpenMedia);    
    }
    
    const changeRoute = (path) =>{
        setIsLoading(true)
        router.push(path).then(() => {
            setIsLoading(false)
        })
    }

    const likeAction = async(index) => {
        if(!userId){
            changeRoute("/signin?redirect=" + router.asPath)
            return
        }
        let newBuzzArr = [...buzzArray]
        newBuzzArr[index].like = "primary"
        newBuzzArr[index].likeCount = newBuzzArr[index].likeCount + 1        
        setBuzzArray(newBuzzArr)

        try {
            await uploadAction(newBuzzArr[index], userId, userFullName, 'liked', "")
        } catch (error) {
            console.log(error);
        }
    }

    const unLikeAction = async(index) => {
        if(!userId){
            changeRoute("/signin?redirect=" + router.asPath)
            return
        }
        let newBuzzArr = [...buzzArray]
        newBuzzArr[index].like = "default"
        newBuzzArr[index].likeCount = newBuzzArr[index].likeCount - 1
        setBuzzArray(newBuzzArr)

        try {
            await removeLikeAction(newBuzzArr[index].entityId, userId, "liked")
        } catch (error) {
            console.log(error)
        }
    }
    
    const openBuzz = (entityId) =>{
        // setIsLoading(true)
        router.push(`/home/buzz/[entityId]`, `/home/buzz/${entityId}`).then(() => {
            setIsLoading(false)
        })
    }

    const getMyBuzz = useCallback(async() =>{        
        try {
            let response;
            if(!userId){
                response = await downloadMyBuzz("", stringsUserId, buzzIncrementSize, buzzLowerLimit)
            } else {
                response = await downloadMyBuzz(userId, stringsUserId, buzzIncrementSize, buzzLowerLimit)
            }
            setIsLoadingBuzz(false);
            if (buzzLowerLimit === 0) {
                setBuzzArray(response);
                globalStore.set(storeKey, response)
                if (response.length < buzzIncrementSize) {
                    setIsShowMoreBuzz(false);
                }
            } else {
                let newItemCount = response.length;
                setBuzzArray(buzzArray => [...buzzArray, ...response]);
                if (newItemCount < buzzIncrementSize) {
                    setIsShowMoreBuzz(false);
                }
            }
        } catch (error) {
            console.log(error);
            setErrorContent({ 'header': "Error getting posts", 'body': "Please try again. If problem persists, contact us at support@stringssg.com" });
            setIsSystemError(true);
            setIsLoadingBuzz(false);
            return
        }
    }, [userId, stringsUserId, buzzIncrementSize, buzzLowerLimit])

    const refreshBuzz = useCallback(async() => {
        return new Promise((resolve) => {
            globalStore.set(storeKey, [])
            setIsShowMoreBuzz(true)
            setIsLoadingBuzz(true); 
            if(buzzLowerLimit === 0){
                getMyBuzz()
            } else {
                setBuzzLowerLimit(0)                
            }            
            resolve("success");
        })
    }, [buzzLowerLimit, getMyBuzz])

    const loadMoreBuzz = async() =>{
        return new Promise((resolve) => {            
            if(buzzArray.length > 0){
                setIsLoadingBuzz(true); 
                setBuzzLowerLimit(buzzLowerLimit + buzzIncrementSize);
            }              
            resolve("success");
        });
    }

    useEffect(() => {     
        if(buzzLowerLimit === 0) return;
        getMyBuzz();
    }, [buzzLowerLimit, getMyBuzz])    

    useEffect(() => {
        if(!stringsUserId) return

        if(buzzLowerLimit > 0 || myPosts.length > 0) return
        if(!globalStore.get(storeKey)){
            getMyBuzz();
        } else {
            if(globalStore.get(storeKey).length === 0){
                getMyBuzz(); 
            } else {
                setBuzzArray(globalStore.get(storeKey))
                setIsLoadingBuzz(false); 
            }
        }
    }, [stringsUserId, buzzLowerLimit, getMyBuzz, myPosts])
    
    const share = async (index) => {
        const title = `${buzzArray[index].userFullNm} Buzz ${buzzArray[index].entityId} - ${buzzArray[index].desc} | StringsSG`
        const url = window.location.origin + "/home/buzz/" + buzzArray[index].entityId
        const result = await shareContent(title, url)
        if (!result.success && result.fallbackData) {
            setShareData(result.fallbackData)
            setShowShareModal(true)
        }
    }

    const deleteBuzz = (entityId) => {
        setEditEntityId(entityId)
        openModal(setIsShowPostDelete)
    }

    const editPrivacy = (entityId, security) => {
        setEditEntityId(entityId)
        setPostSecurity(security)
        openModal(setIsShowPostPrivacy)
    }

    return (
    <>
        {/* Header */}
        <div className='bg-white border-b border-gray-100'>
                <h1 className='text-lg font-semibold text-gray-900 p-3'>Posts</h1>
        </div>

        <motion.div id="my-buzz" className='pb-24'>
            <PullToRefresh
                onRefresh={refreshBuzz}
                pullingContent={<div className='text-sm text-gray-500 text-center'>&#8595; pull to refresh</div>}
                pullDownThreshold={90}
                maxPullDownDistance={200}
            >
                <InfiniteScroll
                    loadMore={loadMoreBuzz}
                    hasMore={isShowMoreBuzz && !isLoadingBuzz}
                    loader={
                        <div className='flex justify-center p-5'>
                            <DotLoader className='m-auto'
                                color={"#fbbf24"}
                                loading={true}
                                size={40}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            />
                        </div>
                    }
                >
                    {/* Loading Skeleton */}
                    {(isLoadingBuzz && buzzArray.length === 0) && (
                        <div className="p-4 space-y-4">
                            {[...Array(3)].map((_, idx) => <SkeletonCard key={idx} />)}
                        </div>
                    )}

                    {/* Empty State */}
                    {(!isLoadingBuzz && buzzArray?.length === 0) && (
                        <div className='text-center py-16'>
                            <div className='w-20 h-20 mx-auto mb-4 rounded-full bg-gray-100 flex items-center justify-center'>
                                <MessageCircle size={32} className='text-gray-400' />
                            </div>
                            <p className='text-gray-500 font-medium'>No posts yet</p>
                            <p className='text-sm text-gray-400 mt-1'>Start sharing your thoughts!</p>
                        </div>
                    )}

                    {/* Posts List */}
                    <div className='space-y-3 my-3 px-1'>
                        {[...buzzArray].map((buzz, i) => (
                            <BuzzCard
                                key={i}
                                buzz={buzz}
                                index={i}
                                viewEntityId={viewEntityId}
                                isMuteVideo={isMuteVideo}
                                isPauseVideo={isPauseVideo}
                                setIsMuteVideo={setIsMuteVideo}
                                setIsPauseVideo={setIsPauseVideo}
                                onViewportEnter={() => setViewEntityId(buzz.entityId)}
                                onOpenImage={openImage}
                                onOpenBuzz={openBuzz}
                                onLike={() => likeAction(i)}
                                onUnlike={() => unLikeAction(i)}
                                onShare={() => share(i)}
                                // Owner-specific props
                                isOwner={userId === stringsUserId}
                                onEditPrivacy={editPrivacy}
                                onDelete={deleteBuzz}
                            />
                        ))}
                    </div>

                    {/* Loading More */}
                    {(isLoadingBuzz && buzzArray?.length > 0) && (
                        <div className='flex justify-center p-5'>
                            <DotLoader className='m-auto'
                                color={"#fbbf24"}
                                loading={true}
                                size={40}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            />
                        </div>
                    )}
                </InfiniteScroll>
            </PullToRefresh>
        </motion.div>

        {/* New Post FAB */}
        {userId === stringsUserId && (
            <motion.button 
                whileHover={{ scale: 1.05, boxShadow: "0 10px 30px rgba(251, 146, 60, 0.3)" }}
                whileTap={{ scale: 0.95 }}
                onClick={() => openModal(setIsShowNewBuzzModal)}
                className='fixed bottom-20 right-4 w-14 h-14 bg-linear-to-br from-orange-500 to-amber-500 rounded-2xl shadow-lg flex items-center justify-center text-white hover:shadow-xl transition-all duration-300'
            >
                <Plus size={24} strokeWidth={2.5} />
            </motion.button>
        )}

        <AnimatePresence>
            {isShowNewBuzzmodal && <NewBuzz refreshBuzz={refreshBuzz}/>}
        </AnimatePresence>
        <AnimatePresence>     
            {isOpenMedia && <ImageModal media={buzzMedia} imageX={imageX} imageY={imageY} mediaType={buzzMediaType}/>}
        </AnimatePresence>
        <AnimatePresence>
            {isShowPostDelete && <BuzzDelete refreshBuzz={refreshBuzz} editEntityId={editEntityId}/>}
        </AnimatePresence>
        <AnimatePresence>
            {isShowPostPrivacy && <BuzzPrivacy refreshBuzz={refreshBuzz} editEntityId={editEntityId} postSecurity={postSecurity}/>}
        </AnimatePresence>
        {isLoading && <LoadingCover/>}
        {isSystemError && <SystemError errorContent={errorContent} setIsSystemError={setIsSystemError}/>}
        <ShareFallbackModal
            isOpen={showShareModal}
            onClose={() => setShowShareModal(false)}
            shareData={shareData}
        />
    </>
  )
}
